module.exports = __webpack_public_path__ + "static/media/ChannelSong.Hindi.5476d50c.jpg";